import styled from 'styled-components';

export const ContainerFooter = styled.div`
  display: flex;
  align-items: center;
`;
